import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, FormGroup, Input } from "reactstrap";
import "./pos-modal.css";

export default function DiscountModal({ isOpen, onClose, products, onApply }) {
  const [discountType, setDiscountType] = useState("percent");
  const [discountValue, setDiscountValue] = useState("");
  const [discountTarget, setDiscountTarget] = useState("all");

  const handleApply = () => {
    onApply({ discountType, discountValue, discountTarget });
    setDiscountValue("");
    setDiscountTarget("all");
  };

  const handleClose = () => {
    setDiscountValue("");
    setDiscountTarget("all");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="sm" className="pos-modal">
      <div className="modal-header">
        <span className="modal-title">Aplicar Desconto</span>
        <button className="pos-modal-close-btn" onClick={handleClose}>×</button>
      </div>
      <ModalBody>
        <FormGroup className="mb-3">
          <label className="pos-modal-label">Produto</label>
          <select
            className="pos-modal-select"
            value={discountTarget}
            onChange={(e) => setDiscountTarget(e.target.value)}
          >
            <option value="all">Todos os produtos</option>
            {products.map((p, i) => (
              <option key={i} value={String(i)}>
                {p.ProductName}
              </option>
            ))}
          </select>
        </FormGroup>

        <FormGroup className="mb-3">
          <label className="pos-modal-label">Tipo de desconto</label>
          <div className="pos-discount-type-toggle">
            <button
              className={`pos-discount-type-btn${discountType === "percent" ? " active" : ""}`}
              onClick={() => setDiscountType("percent")}
            >
              % Percentual
            </button>
            <button
              className={`pos-discount-type-btn${discountType === "fixed" ? " active" : ""}`}
              onClick={() => setDiscountType("fixed")}
            >
              R$ Valor fixo
            </button>
          </div>
        </FormGroup>

        <FormGroup className="mb-0">
          <label className="pos-modal-label">
            {discountType === "percent" ? "Percentual (%)" : "Valor (R$)"}
          </label>
          <Input
            type="number"
            min="0"
            max={discountType === "percent" ? "100" : undefined}
            placeholder={discountType === "percent" ? "Ex: 10" : "Ex: 50"}
            value={discountValue}
            onChange={(e) => setDiscountValue(e.target.value)}
            className="pos-modal-input"
            autoFocus
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <button
          className="pos-modal-btn pos-modal-btn--primary"
          onClick={handleApply}
        >
          Aplicar
        </button>
        <button
          className="pos-modal-btn pos-modal-btn--secondary"
          onClick={handleClose}
        >
          Cancelar
        </button>
      </ModalFooter>
    </Modal>
  );
}
